import gtagEventEmitter from "helpers/gtagEventEmitter";
import Button from "@Components/Button";
import styles from "./VirtualTourConnectSection.module.scss";
import Image from "@Components/Image";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import LeadFormDispatcher from "@Components/LeadFormModal/actions";
import { AppState } from "@Store/index";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import useIsDesktop from "hooks/useIsDesktop";
import useWhitelabel from "hooks/useWhitelabel";
//

const ConnectSection = () => {
  const isDesktop = useIsDesktop();
  const { data } = useSelector(
    ({ propertyPageData }: AppState) => ({
      data: propertyPageData.data,
    }),
    shallowEqual,
  );

  const dispatch = useDispatch();
  const { t } = useTranslationHook();
  const { isWhitelabel } = useWhitelabel();

  const openLeadFormHandler = async () => {
    gtagEventEmitter({
      action: "clicked_property_viewing_request",
      category: "property_viewing_request",
    });

    const leadFormDispatcher = new LeadFormDispatcher(dispatch);
    leadFormDispatcher.handleOnEnquireClick({
      heading: t("propertypage.virtualtourconnect.virtualtourrequestheadingstring"),
      data,
      source: "virtual_tour_enquiry",
      page: 1,
    });
  };

  if (isWhitelabel) return null;

  return (
    <>
      <div
        role="none"
        className={formatClassNames(
          styles.sectionContainer,
          isDesktop && styles.sectionContainerDesktop,
        )}
        onClick={openLeadFormHandler}
      >
        <div
          className={formatClassNames(
            styles.outerContainer,
            isDesktop && styles.outerContainerDesktop,
          )}
          data-testid="Connect-Section"
        >
          <Image
            height=""
            width=""
            src="https://prod-static-assets.amberstudent.com/images/360-degree-rotate-icon.svg"
            className={formatClassNames(styles.facebookImg, isDesktop && styles.facebookImgDesktop)}
            alt="360 degree rotate icon"
          />
          <div
            className={formatClassNames(
              styles.leftContainer,
              isDesktop && styles.leftContainerDesktop,
            )}
          >
            <div
              className={formatClassNames(
                styles.textContainer,
                isDesktop && styles.textContainerDesktop,
              )}
            >
              <p
                data-testid="Interested in the "
                className={formatClassNames(
                  isWhitelabel ? "wl-title-font" : "",
                  styles.title,
                  isDesktop && styles.titleDesktop,
                )}
              >
                {t("propertypage.virtualtourconnect.interestedinpropertystring")}
                <span className={styles.titleRed}>property?</span>
              </p>

              <p
                data-testid="Get-help-text"
                className={formatClassNames(styles.text, isDesktop && styles.textDesktop)}
              >
                {t("propertypage.virtualtourconnect.bookyourstring")}{" "}
                <span className={styles.titleRed}>
                  {t("propertypage.virtualtourconnect.livestring")}{" "}
                </span>
                {t("propertypage.virtualtourconnect.tourtodaystring")}
              </p>
            </div>

            <Button
              dataTestId="Request now"
              className={formatClassNames(styles.mainActionBtn, styles.mainActionBtnDesktop)}
              variant="outline"
              color="primary.4"
              onClick={openLeadFormHandler}
            >
              {t("propertypage.virtualtourconnect.requestnowstring")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default wrapperHOC(ConnectSection, {
  componentName: "ConnectSection",
  showForChina: false,
  showForApp: false,
});
